import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

import room1 from '../assets/rooms/1.png'
import room2 from '../assets/rooms/2.png'
import room3 from '../assets/rooms/3.png'
import room4 from '../assets/rooms/4.png'
import room5 from '../assets/rooms/5.png'
import room6 from '../assets/rooms/6.png'
import room7 from '../assets/rooms/7.jpg'
import room8 from '../assets/rooms/8.png'
import room9 from '../assets/rooms/9.jpg'
import room10 from '../assets/rooms/10.jpg'
import room11 from '../assets/rooms/11.jpg'


SwiperCore.use([Navigation]);

const RoomSlider = () => {
    const allroom = [room1, room2, room3, room4, room5, room6, room7, room8, room9, room10, room11]

    return (
        <>
            <Swiper
                breakpoints={{
                    640: {
                        width: 640,
                        slidesPerView: 1,
                    },
                    768: {
                        width: 768,
                        slidesPerView: 2,
                    },
                }}
                id="main"
                width="400"
                navigation
                spaceBetween={10}
                slidesPerView={1}
            >



                {allroom.map((oneRoom, index) => (
                    <SwiperSlide key={index}>
                        <img
                            style={{ width: '100%',height: '250px' ,borderRadius:'20px'}}
                            src={oneRoom}
                            alt="room"
                            loading='lazy'
                        />
                    </SwiperSlide>
                ))}

            </Swiper>
        </>
    )
}
export default RoomSlider
